export const environment = {
  firebase: {
    options: {
      projectId: 'fido-dabc6',
      appId: '1:716810271951:web:931448a163bc3c772e4bba',
      storageBucket: 'fido-dabc6.firebasestorage.app',
      apiKey: 'AIzaSyCOam4FdEzqIPZMxULaKUbpgNxqrxzCLzo',
      authDomain: 'fido-dabc6.firebaseapp.com',
      messagingSenderId: '716810271951',
      measurementId: 'G-GX9K8D0QDB',
    },
    appCheck: {
      siteKey: '6LeLSFosAAAAAM6_6Hw4zyrq8nSlRAkirqeK542V',
    },
  },
  fingerprintjs: {
    apiKey: 'W30PP3fNqToaKXVNL8VC',
  },
  intakeApiBaseUrl: '',
};
